import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getProperties as getPropertiesAPI } from '../services/api';
import PropertyCard from '../components/PropertyCard';
import './PropertyListing.css';

const PropertyListing = () => {
    const navigate = useNavigate();
    const [properties, setProperties] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({
        location: '',
        type: '',
        price: ''
    });

    useEffect(() => {
        loadProperties();
    }, []);

    const loadProperties = async () => {
        try {
            setLoading(true);
            const data = await getPropertiesAPI(filters);
            setProperties(data || []);
        } catch (error) {
            console.error('Error loading properties:', error);
            setProperties([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadProperties();
    }, [filters]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const clearFilters = () => {
        setFilters({
            location: '',
            type: '',
            price: ''
        });
    };

    const checkPriceRange = (price, range) => {
        if (range === '0-500000') {
            return price <= 500000;
        } else if (range === '500000-1000000') {
            return price > 500000 && price <= 1000000;
        } else if (range === '1000000-2000000') {
            return price > 1000000 && price <= 2000000;
        } else if (range === '2000000+') {
            return price > 2000000;
        }
        return true;
    };

    return (
        <div className="property-listing-page">
            <div className="listing-header">
                <div className="container">
                    <div className="header-content">
                        <div>
                            <h1>All Properties</h1>
                            <p>Find your perfect property from our extensive collection</p>
                        </div>
                        <button onClick={() => navigate('/')} className="back-home-btn">
                            <i className="fas fa-arrow-left"></i> Back to Home
                        </button>
                    </div>
                </div>
            </div>

            <div className="listing-content">
                <div className="container">
                    <div className="listing-layout">
                        <div className="filters-sidebar">
                            <div className="filters-card">
                                <h3>Filter Properties</h3>
                                
                                <div className="filter-group">
                                    <label>Location</label>
                                    <input
                                        type="text"
                                        name="location"
                                        placeholder="Search location..."
                                        value={filters.location}
                                        onChange={handleFilterChange}
                                    />
                                </div>

                                <div className="filter-group">
                                    <label>Property Type</label>
                                    <select
                                        name="type"
                                        value={filters.type}
                                        onChange={handleFilterChange}
                                    >
                                        <option value="">All Types</option>
                                        <option value="apartment">Apartment</option>
                                        <option value="villa">Villa</option>
                                        <option value="townhouse">Townhouse</option>
                                        <option value="penthouse">Penthouse</option>
                                        <option value="office">Office</option>
                                    </select>
                                </div>

                                <div className="filter-group">
                                    <label>Price Range</label>
                                    <select
                                        name="price"
                                        value={filters.price}
                                        onChange={handleFilterChange}
                                    >
                                        <option value="">All Prices</option>
                                        <option value="0-500000">Up to $500,000</option>
                                        <option value="500000-1000000">$500,000 - $1,000,000</option>
                                        <option value="1000000-2000000">$1,000,000 - $2,000,000</option>
                                        <option value="2000000+">$2,000,000+</option>
                                    </select>
                                </div>

                                <button onClick={clearFilters} className="clear-filters-btn">
                                    <i className="fas fa-times"></i> Clear Filters
                                </button>
                            </div>
                        </div>

                        <div className="properties-section">
                            <div className="results-header">
                                <h2>
                                    {loading ? 'Loading...' : `${properties.length} Properties Found`}
                                </h2>
                            </div>

                            {loading ? (
                                <div className="loading-state">
                                    <i className="fas fa-spinner fa-spin"></i>
                                    <p>Loading properties...</p>
                                </div>
                            ) : properties.length === 0 ? (
                                <div className="empty-state">
                                    <i className="fas fa-inbox"></i>
                                    <h3>No Properties Found</h3>
                                    <p>Try adjusting your filters or check back later</p>
                                    <button onClick={clearFilters} className="clear-filters-btn">
                                        Clear All Filters
                                    </button>
                                </div>
                            ) : (
                                <div className="properties-grid-listing">
                                    {properties.map(property => (
                                        <PropertyCard key={property.id} property={property} />
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PropertyListing;
